// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2IveZ","errorLogs":"styles_errorLogs__1MG0U"};